import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@ubeya/shared-web/components';

const WarningDot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.redNegative};
  margin-right: 6px;
  cursor: help;
  vertical-align: middle;
`;

const BreakWarningIndicator = ({ breakWarnings }) => {
  const tooltip = useMemo(
    () =>
      Array.isArray(breakWarnings) && breakWarnings.length > 0
        ? breakWarnings
            .map((w) => w?.message)
            .filter(Boolean)
            .join('\n')
        : null,
    [breakWarnings]
  );

  if (!tooltip) {
    return null;
  }

  return (
    <Tooltip body={tooltip}>
      <WarningDot />
    </Tooltip>
  );
};

export default BreakWarningIndicator;
